// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

const importAll = (r) => r.keys().map(r)
importAll(require.context('images', false, /\.(png|jpe?g|svg)$/i));
//importAll(require.context('@fortawesome/fontawesome-pro/webfonts', false, /\.(eot|svg|ttf|woff2?)$/i));

import $ from 'jquery'
import * as CoreUI from "@coreui/coreui-pro"
global.$ = $
global.jQuery = $
require("node-json2html/json2html.js")

global.coreui = CoreUI;
import "simplebar";
import * as multiSelect from "../shared/multi_select";
global.multiSelect = multiSelect;

import "stylesheets/application";

import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
global.Rails = Rails

global.Rails.start();

require("@rails/activestorage").start()
require("channels")
global.Trix = require("@mixtint/trix")
require("@rails/actiontext")

import "ninja-keys";
import "turbo/coreui";

import * as echarts from 'echarts/core';
import { withCoreuiTheme } from '../echart-helper/theme';
import {
  BarChart,
  LineChart,
  GaugeChart,
  HeatmapChart,
  PieChart,
  PictorialBarChart,
  MapChart,
  ScatterChart
} from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  CalendarComponent,
  ToolboxComponent,
  LegendComponent,
  VisualMapComponent,
  MarkLineComponent,
  GeoComponent,
  DataZoomComponent,
} from 'echarts/components';
import {
  CanvasRenderer
} from 'echarts/renderers';
import {
  AxisBreak,
  LabelLayout
} from 'echarts/features';

echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, CalendarComponent, ToolboxComponent, LegendComponent, VisualMapComponent, MarkLineComponent, GeoComponent, DataZoomComponent,
   BarChart, LineChart, GaugeChart, HeatmapChart, PieChart, PictorialBarChart, MapChart, ScatterChart,
   CanvasRenderer, AxisBreak, LabelLayout]
);
global.echarts = withCoreuiTheme(echarts);

import "controllers";

// Load DataTables and its Bootstrap 5 integrations. DataTables 1.13 exposes
// ESM entry points, so loading the modules installs them on the shared jQuery
// instance without the legacy `(window, $)` factory call.
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-colreorder';
import 'datatables.net-fixedheader';
import 'datatables.net-select';
import 'datatables.net-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-colreorder-bs5';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-fixedheader-bs5';
import 'datatables.net-select-bs5';
// require('yadcf')(window, $); // Uncomment if you use yadcf (need a recent version of yadcf)

require("devise-jwt");

$.extend( $.fn.dataTable.defaults, {
  lengthMenu: [ 12, 25, 50, 75, 100 ],
  dom:
    "<'row'<'col-sm-12 col-md-2'B><'col-sm-12 col-md-7'l><'col-sm-12 col-md-3'f>>" +
    "<'row'<'col-sm-12'tr>>" +
    "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
  colReorder: true,
  buttons: ['colvis'],
  language: {
    "emptyTable":     "表中数据为空",
    "info":           "显示第 _START_ 至 _END_ 项结果，共 _TOTAL_ 项",
    "infoEmpty":      "显示第 0 至 0 项结果，共 0 项",
    "infoFiltered":   "(由 _MAX_ 项结果过滤)",
    "infoThousands":  ",",
    "lengthMenu":     "显示数量 _MENU_",
    "loadingRecords": "载入中...",
    "processing":     "处理中...",
    "search":         "搜索:",
    "zeroRecords":    "没有匹配结果",
    "buttons": {
      "colvis": "列可见性",
      "colvisRestore": "恢复列可见性",
    },
    "thousands": ",",
    "paginate": {
      "first":    "第一页",
      "last":     "最后一页",
      "next":     "下一页",
      "previous": "上一页"
    },
    "aria": {
      "sortAscending":  ": 以升序排列此列",
      "sortDescending": ": 以降序排列此列"
    }
  }
} );

const coreuiJQueryBridge = (pluginName, Component) => {
  $.fn[pluginName] = function(commandOrOptions) {
    this.each(function() {
      const instance = Component.getOrCreateInstance(this, typeof commandOrOptions === "object" ? commandOrOptions : undefined);
      const command = typeof commandOrOptions === "string" ? commandOrOptions : (pluginName === "modal" ? "show" : null);
      if (command && typeof instance[command] === "function") instance[command]();
    });
    return this;
  };
};

const installCoreUIJQueryBridges = () => {
  coreuiJQueryBridge("modal", CoreUI.Modal);
  coreuiJQueryBridge("collapse", CoreUI.Collapse);
  coreuiJQueryBridge("popover", CoreUI.Popover);
  coreuiJQueryBridge("tooltip", CoreUI.Tooltip);
};

installCoreUIJQueryBridges();

// CoreUI installs its own jQuery adapters on DOMContentLoaded. Reinstall our
// compatibility adapters afterward so legacy calls such as `.modal()` still
// show the component instead of only initializing it.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", installCoreUIJQueryBridges);
}

document.addEventListener("turbo:load", function() {
  $("figure>img").on( "click", function() {
    $("#knowledge-edit-modal").html(`
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <img src="${$(this).attr('src')}">
  </div>
</div>`).modal('show');
  });

  $('button[data-coreui-toggle="popover"]').popover();
});
